import TextInput from 'components/form/TextInput';
import React from 'react';
// Final Thank You Email for unregistered participants
const TwentyOneStepOfFollowUps = ({ props, isEdit, suggestionData }) => {
  // const { handleChange, values } = props;
  const { values, errors, touched, handleChange, handleBlur } = props;

  const {
    client_name,
    conference_short_name,
    photo_access_link,
    upcoming_conference_link,
    your_name,
    contact_details,
  } = values;
  return (
    <>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Client Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="client_name"
            onChange={handleChange}
            value={client_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.client_name && errors.client_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference Short Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_short_name"
            onChange={handleChange}
            value={conference_short_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.conference_short_name && errors.conference_short_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Photo Access Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="photo_access_link"
            onChange={handleChange}
            value={photo_access_link}
            disabled={!isEdit}
            suggestions={suggestionData?.photo_access_link}
            onBlur={handleBlur}
            error={touched.photo_access_link && errors.photo_access_link}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Upcoming Conference Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="upcoming_conference_link"
            onChange={handleChange}
            value={upcoming_conference_link}
            disabled={!isEdit}
            suggestions={suggestionData?.upcoming_conference_link}
            onBlur={handleBlur}
            error={touched.upcoming_conference_link && errors.upcoming_conference_link}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_name"
            onChange={handleChange}
            value={your_name}
            disabled={!isEdit}
            suggestions={suggestionData?.your_name}
            onBlur={handleBlur}
            error={touched.your_name && errors.your_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Contact Details
        </div>
        <div className="col-lg-6">
          <TextInput
            id="contact_details"
            onChange={handleChange}
            value={contact_details}
            disabled={!isEdit}
            suggestions={suggestionData?.contact_details}
            onBlur={handleBlur}
            error={touched.contact_details && errors.contact_details}
          />
        </div>
      </div>
    </>
  );
};

export default TwentyOneStepOfFollowUps;
